import React from 'react'
import { Card, Container } from 'react-bootstrap'
import { MoonStars } from 'react-bootstrap-icons'
import logoCenec from '../assets/cenec_2.svg'
import logoChorotega from '../assets/chorotega_2.svg'

export const ServiceClosed = ({ data }) => {
    const open = data?.open || '6:00 AM'
    const close = data?.close || '10:00 PM'
    const message = data?.message || `Nuestro servicio de pagos está disponible de ${open} a ${close}.`

    return (
        <Container style={{ maxWidth: '560px' }} className="py-5">
            <Card
                className="border-0 text-center"
                style={{ borderRadius: '20px', boxShadow: '0 10px 40px rgba(16,24,40,.08)', overflow: 'hidden' }}
            >
                <Card.Body className="px-4 pt-5 pb-4">
                    <div
                        style={{
                            width: 96, height: 96, borderRadius: '50%', backgroundColor: '#eaf5ee',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem'
                        }}
                    >
                        <MoonStars size={44} style={{ color: '#047732' }} />
                    </div>

                    <h1 className="h3 fw-bold mb-2" style={{ color: '#0f2a1a' }}>Volvemos pronto</h1>
                    <p className="text-muted mb-4" style={{ fontSize: '1.05rem', lineHeight: 1.6 }}>{message}</p>

                    <div
                        className="d-inline-flex align-items-center gap-2 px-3 py-2"
                        style={{ backgroundColor: '#f3f7f4', borderRadius: '999px', color: '#047732', fontWeight: 600 }}
                    >
                        <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#d64545', display: 'inline-block' }}></span>
                        Fuera de horario · {open} a {close}
                    </div>

                    <p className="text-muted mt-4 mb-0" style={{ fontSize: '.9rem' }}>
                        Gracias por tu preferencia. Te esperamos dentro del horario de atención.
                    </p>
                </Card.Body>

                <Card.Footer className="border-0" style={{ backgroundColor: '#ffffff' }}>
                    <div
                        className="d-flex justify-content-center align-items-center gap-4 chorotega-bg-color mx-3 p-3"
                        style={{ borderRadius: '14px' }}
                    >
                        <img src={logoCenec} alt="CENEC" style={{ maxHeight: 34 }} />
                        <div style={{ width: 1, height: 30, backgroundColor: 'rgba(255,255,255,.4)' }}></div>
                        <img src={logoChorotega} alt="Cooperativa Chorotega" style={{ maxHeight: 34 }} />
                    </div>
                </Card.Footer>
            </Card>
        </Container>
    )
}
